import React from 'react';
import { DownloadCardProps, SearchResultsContainerProps } from './../../../types/search';
import { useSearchConfig } from '../../Search/hooks/useSearchConfig';

const DocumentCard = ({
  data,
  downloadLabel,
  lastUpdatedLabel,
}: {
  data: DownloadCardProps;
  downloadLabel?: string;
  lastUpdatedLabel?: string;
}) => {
  return (
    <a
      href={data.url}
      data-type={data.type}
      className="documents__downloads-card"
      download
      aria-label={`${downloadLabel} ${data.heading}`}
    >
      <div className="documents__downloads-card-top">
        {data.docTag && <span className="documents__downloads-card-type">{data.docTag}</span>}
        <div className="documents__downloads-card-meta">
          <svg className="documents__downloads-filetype-icon">
            <use href="/dist/assets/icons/sprite.svg#document"></use>
          </svg>
        </div>
        <div className="documents__downloads-card-content">
          <h2 className="documents__downloads-card-title">{data.heading}</h2>
          {data.startPublish && (
            <p className="documents__downloads-card-description">
              {lastUpdatedLabel} {data.startPublish}
            </p>
          )}
        </div>
      </div>
      <span className="documents__downloads-card-download-text-wrapper">
        <span className="sr-only documents__downloads-card-download-text">{downloadLabel ?? 'Download'}</span>
        <svg className="documents__downloads-download-icon">
          <use href="/dist/assets/icons/sprite.svg#download"></use>
        </svg>
      </span>
    </a>
  );
};

const DocumentsListingSearchResultsContainer = ({ results }: SearchResultsContainerProps) => {
  const config = useSearchConfig();

  return (
    <div className="content-grid-block__grid documents__results-grid">
      {results.map(result => (
        <DocumentCard
          key={result.id || result.heading + result.url}
          data={result as DownloadCardProps}
          downloadLabel={config.labels.downloadLabel}
          lastUpdatedLabel={config.labels.lastUpdatedLabel}
        />
      ))}
    </div>
  );
};

export default DocumentsListingSearchResultsContainer;
